import { useEffect, useState } from 'react';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { PaginationOffsetResponseInterface } from '@interface/logs/response-data.interface';

import { NextIcon, PaginationWrapper, PrevIcon } from './pagination.style';

interface PaginationProps {
  pagination: PaginationOffsetResponseInterface;
  onPage: (page: number) => void;
}

export const PaginationOffset = ({ pagination, onPage }: PaginationProps) => {
  const [currentPage, setCurrentPage] = useState(0);

  const hasNext = (currentPage + 1) * pagination.limit < pagination.total;
  const hasPrevious = currentPage > 0;

  useEffect(() => void onPage(currentPage), [currentPage]);

  if (!hasNext && !hasPrevious) return null;

  return (
    <PaginationWrapper>
      <Button disabled={!hasPrevious} type={ButtonTypeEnum.Link} onClick={() => setCurrentPage(currentPage - 1)}>
        <PrevIcon isDisabled={!hasPrevious} />
      </Button>
      <Button disabled={!hasNext} type={ButtonTypeEnum.Link} onClick={() => setCurrentPage(currentPage + 1)}>
        <NextIcon isDisabled={!hasNext} />
      </Button>
    </PaginationWrapper>
  );
};
